import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
import { SlotKey } from '../types';

export const LINES = ['line1', 'line2', 'line3', 'line4'] as const;

export type LineTab = (typeof LINES)[number];

export const LineViewTabsContext = createContext<{selected: LineTab, setSelected: (tab: LineTab) => void}>({selected: 'line1', setSelected: () => {}});

export const slotsForLine = {
  line1: { goal: ['goal', 'goalsub'], def: ['def1', 'def2'], for: ['for1', 'for2', 'for3'] },
  line2: { goal: ['goal', 'goalsub'], def: ['def3', 'def4'], for: ['for4', 'for5', 'for6'] },
  line3: { goal: ['goal', 'goalsub'], def: ['def5', 'def6'], for: ['for7', 'for8', 'for9'] },
  line4: { goal: ['goal', 'goalsub'], def: ['def7'], for: ['for10', 'for11', 'for12'] },
} satisfies Record<LineTab, { goal: SlotKey[]; def: SlotKey[]; for: SlotKey[] }>;

export const flatSlotsForLine = {
  line1: [ ...slotsForLine.line1.goal, ...slotsForLine.line1.def, ...slotsForLine.line1.for, ],
  line2: [ ...slotsForLine.line2.goal, ...slotsForLine.line2.def, ...slotsForLine.line2.for, ],
  line3: [ ...slotsForLine.line3.goal, ...slotsForLine.line3.def, ...slotsForLine.line3.for, ],
  line4: [ ...slotsForLine.line4.goal, ...slotsForLine.line4.def, ...slotsForLine.line4.for, ],
} satisfies Record<LineTab, SlotKey[]>;

export const WithLineViewTabs: React.FC<PropsWithChildren<{initiallySelected?: LineTab}>> = ({children, initiallySelected}) => {
  const [selected, setSelected] = useState<LineTab>(initiallySelected ?? LINES[0]);
  return <LineViewTabsContext.Provider value={{selected, setSelected}}>
    {children}
  </LineViewTabsContext.Provider>
}

export const useLineSlots = () => {
  const {selected, setSelected} = useContext(LineViewTabsContext);
  return {selected, setSelected, slots: slotsForLine[selected]};
}
